import React from 'react'
import { getIconClass } from "../../utils/sectionHelpers";
import { Link } from "react-router-dom"
import DynamicImage from "./DynamicImage";
import { useLocation } from "react-router-dom";
const IndustiresCard = ({ data }) => {
      const location = useLocation();
      const isHomePage = location.pathname === "/";
    return (
        <>
            {data.industriesCard?.map((card) => (
                <div className="col-lg-4 col-md-6 col-sm-12" key={card.id} data-aos="fade-up" data-aos-duration="1200">
                    <div className="single-solutions-box">
                        <div className="icon">
                            {card?.image ? (
                               <DynamicImage image={card.image} />
                            ) : (
                                <i className={getIconClass(card.title)}></i>
                            )}
                        </div>
                        <h3>
                            {card.header_menu?.page?.slug ? (
                                <Link to={`${card.header_menu?.parent?.slug}/${card.header_menu?.page?.slug}`}>
                                    {card.title}
                                </Link>
                            ) : (
                                card?.title || card.title
                            )
                            }
                        </h3>

                        <p>
                            {card.description}
                        </p>
                        {isHomePage && (
                        card.header_menu?.page?.slug ? (
                            <Link to={`${card.header_menu?.parent?.slug}/${card.header_menu?.page?.slug}`} className="view-details-btn">
                                Learn More
                            </Link>
                        ) : (
                            <Link to="#" onClick={(e) => e.preventDefault()} className="view-details-btn">
                                Learn More
                            </Link>
                        )
                    )}
                    </div>
                </div>
            ))}
        </>
    )
}

export default IndustiresCard